// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {useStore} from '@nanostores/react';
import {$user} from '../../../store/user.js';
import {Panel} from '../../../comp/panel';
import {Text} from '../../../comp/text';
import {Button} from '../../../comp/button';
import {Invite_sharer} from '../../../comp/invite_sharer';
import {Profile_popup} from '../../../features/profile_popup';
import {Status} from './status.js';
import {Lifetime} from './lifetime.js';
import * as cns from './head.module.less';

function Settings_btn({on_click}){
    return <Button className={cns.settings} ico="settings" view="link"
      right_shift color_scheme="accent" on_click={on_click}
      tip="User settings">
      Settings
    </Button>;
}

export function Head(){
    const user = useStore($user);
    return <div className={cns.root}>
      <div className={cns.header_row}>
        <Text.xxxl h1>My profile</Text.xxxl>
        <Profile_popup user={user} trigger_elem={Settings_btn}/>
      </div>
      <Lifetime/>
      <div className={cns.row}>
        <Status/>
        <Panel>
          <Invite_sharer/>
        </Panel>
      </div>
    </div>;
}
